import { defineMessage } from 'services/localization';

export const messages = {
    statusNotReceived: defineMessage('not_received'),
    statusPartiallyReceived: defineMessage('partially_received'),
    statusFullyReceived: defineMessage('fully_received'),
};
